import React, { useEffect, useState } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import { razerPayGet, razerPayUpdate } from "../api";
import { notifyError, notifySuccess } from "src/assets/toastService";

const paymentGateways = [
    "Razorpay",
    // "PayPal",
    // "Stripe",
    // "PhonePe",
    // "Cashfree",
    // "PayU",
    // "Square",
];

interface PaymentGateway {
    createdBy: string;
    createdOn: string;
    gateway: string;
    isActive: boolean;
    keyId: string;
    mode: "TEST" | "LIVE";
    orgId: string;
    webhookSecret: string;
}

interface PaymentGatewayConfigResponse {
    success: boolean;
    data: PaymentGateway;
}

function PaymentGatewayConfig() {
    const [enabled, setEnabled] = useState<boolean>(false);

    const [gateway, setGateway] = useState<string>("Razorpay");
    const [mode, setMode] = useState<"TEST" | "LIVE">("TEST");
    const [keyId, setKeyId] = useState<string>("");
    const [keySecret, setKeySecret] = useState<string>("");
    const [webhookSecret, setWebhookSecret] = useState<string>("");

    const isSaveEnabled =
        enabled &&
        gateway.trim() !== "" &&
        keyId.trim() !== "" &&
        keySecret.trim() !== "";

    const handleSave = () => {
        const payload = {
            gateway,
            mode,
            keyId,
            keySecret,
            webhookSecret,
            isActive: enabled,
        };

        razerPayUpdate(payload)
            .then((res) => {
                console.log("Update Success:", res.data);
                notifySuccess("Configuration saved successfully.");
            })
            .catch((err) => {
                console.error(err);
                notifyError("Failed to save configuration.");
            });
    };

    const getPaymentConfig = () => {
        razerPayGet()
            .then((res) => {
                const response: PaymentGatewayConfigResponse = res;
                if (response.success) {
                    const config = response.data;

                    setEnabled(Boolean(config.isActive));
                    setGateway(config.gateway);
                    setMode(config.mode);
                    setKeyId(config.keyId);
                    setWebhookSecret(config.webhookSecret);
                    // GET API doesn't return keySecret
                    setKeySecret("");
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        getPaymentConfig();
    }, []);

    return (
        <div className="w-full p-4">
            <div className="bg-white rounded-xl shadow border p-6 space-y-5">
                <h2 className="text-lg font-semibold">
                    Payment Gateway Configuration
                </h2>

                {/* Enable Payment */}
                <label className="flex items-center gap-3 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={enabled}
                        onChange={(e) => setEnabled(e.target.checked)}
                    />
                    <span>Enable Payment Gateway</span>
                </label>

                {enabled && (
                    <>
                        {/* Gateway */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Payment Gateway
                            </label>

                            <select
                                value={gateway}
                                onChange={(e) => setGateway(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            >
                                {paymentGateways.map((item) => (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Mode */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Mode
                            </label>

                            <select
                                value={mode}
                                onChange={(e) =>
                                    setMode(e.target.value as "TEST" | "LIVE")
                                }
                                className="w-full border rounded-lg px-3 py-2"
                            >
                                <option value="TEST">TEST</option>
                                <option value="LIVE">LIVE</option>
                            </select>
                        </div>

                        {/* Key ID */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Key ID
                            </label>

                            <input
                                type="text"
                                value={keyId}
                                onChange={(e) => setKeyId(e.target.value)}
                                placeholder="Enter Key ID"
                                className="w-full border rounded-lg px-3 py-2"
                            />
                        </div>

                        {/* Key Secret */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Key Secret
                            </label>

                            <input
                                type="password"
                                value={keySecret}
                                onChange={(e) => setKeySecret(e.target.value)}
                                placeholder="Enter Key Secret"
                                className="w-full border rounded-lg px-3 py-2"
                            />
                        </div>

                        {/* Webhook Secret */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Webhook Secret
                            </label>

                            <input
                                type="password"
                                value={webhookSecret}
                                onChange={(e) => setWebhookSecret(e.target.value)}
                                placeholder="Enter Webhook Secret"
                                className="w-full border rounded-lg px-3 py-2"
                            />
                        </div>

                        <div className="flex justify-center pt-3">
                            <Button
                                label="Save Configuration"
                                onClick={handleSave}
                                disabled={!isSaveEnabled}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default PaymentGatewayConfig;